const { __ } = wp.i18n;
const { Component, Fragment } = wp.element;

const {
  PanelBody,
  PanelRow,
  SelectControl,
  ToggleControl,
  TextControl
} = wp.components;
const { AlignmentToolbar } = wp.editor;
export default class Settings extends Component {
  constructor() {
    super(...arguments);
  }
  render() {
    const {
      attributes: { theme, counter, order, likeButtonSize, showTotalCount },
      setAttributes
    } = this.props;
    return (
      <Fragment>
        <PanelBody
          title={__("Theme")}
          initialOpen={true}
          className={"ssb_panel_wrapper"}
        >
          <PanelRow>
            <SelectControl
              value={theme}
              options={[
                { label: "Theme1", value: "sm-round" },
                { label: "Theme2", value: "simple-round" },
                { label: "Theme3", value: "round-txt" },
                { label: "Theme4", value: "round-btm-border" },
                { label: "Flat", value: "flat-button-border" },
                { label: "Circle", value: "round-icon" },
                { label: "Official", value: "simple-icons" }
              ]}
              onChange={theme => setAttributes({ theme })}
            />
          </PanelRow>
        </PanelBody>
        <PanelBody
          title={__("Configuration")}
          initialOpen={true}
          className={"ssb_panel_wrapper"}
        >
          <PanelRow>
            <ToggleControl
              label={__("Share Counter")}
              checked={counter}
              onChange={counter => {
                setAttributes({ counter: !!counter });
              }}
            />
            {counter && 
            <ToggleControl
              label={__("Total Counts")}
              checked={showTotalCount}
              onChange={showTotalCount => {
                setAttributes({ showTotalCount: !!showTotalCount });
              }}
            />
          }

            <TextControl
              help={
                "Supported Networks: fbshare,twitter,linkedin,pinterest,reddit,whatsapp,viber,tumblr,messenger,email,print,fblike,copylink,threads,telegram,bluesky"
              }
              label={__("Order")}
              value={order}
              onChange={order => {
                setAttributes({ order });
              }}
            />
            <SelectControl
              label={__("Like button size")}
              value={likeButtonSize}
              options={[
                { label: "Small", value: "small" },
                { label: "Large", value: "large" }
              ]}
              onChange={size => setAttributes({ likeButtonSize: size })}
            />
          </PanelRow>
        </PanelBody>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// blocks/shortcode/settings.js